export const blockIconsHouseholdValveNew = (
	<span className='material-symbols-outlined'>valve</span>
);
